(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amare-bed-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFinder(root) {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      var sid = root.id.replace('al-finder-', '');
      var productNode = document.getElementById('al-finder-products-' + sid);
      var rulesNode = document.getElementById('al-finder-rules-' + sid);
      if (!productNode || !rulesNode) return;

      var products = [];
      var rawRules = {};
      try { products = JSON.parse(productNode.textContent) || []; } catch (error) { products = []; }
      try { rawRules = JSON.parse(rulesNode.textContent) || {}; } catch (error) { rawRules = {}; }

      function normalise(value) {
        return String(value || '')
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/&/g, ' and ')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();
      }

      function splitKeywords(value) {
        return String(value || '').split(/[,|\n]+/).map(normalise).filter(Boolean);
      }

      function parseRuleMap(value) {
        return String(value || '').split(/\n+/).reduce(function (map, line) {
          var separator = line.indexOf('=');
          if (separator < 1) return map;
          var key = normalise(line.slice(0, separator)).replace(/ /g, '-');
          map[key] = splitKeywords(line.slice(separator + 1));
          return map;
        }, {});
      }

      function hasPhrase(text, phrase) {
        return (' ' + text + ' ').indexOf(' ' + phrase + ' ') > -1;
      }

      var rules = {
        storage: splitKeywords(rawRules.storage),
        style: parseRuleMap(rawRules.style),
        colour: parseRuleMap(rawRules.colour),
        fabric: parseRuleMap(rawRules.fabric)
      };

      function detectSize(value) {
        var text = normalise(value);
        if (hasPhrase(text, 'super king') || hasPhrase(text, '6ft')) return 'super-king';
        if (hasPhrase(text, 'small single') || hasPhrase(text, '2ft 6')) return 'small-single';
        if (hasPhrase(text, 'small double')) return 'small-double';
        if (hasPhrase(text, '4ft 6')) return 'double';
        if (hasPhrase(text, '4ft')) return 'small-double';
        if (hasPhrase(text, 'king') || hasPhrase(text, '5ft')) return 'king';
        if (hasPhrase(text, 'double')) return 'double';
        if (hasPhrase(text, 'single') || hasPhrase(text, '3ft')) return 'single';
        return null;
      }

      products = products.map(function (product) {
        product.titleKey = normalise(product.title);
        product.sizes = [];
        (product.variantTitles || []).concat([product.title]).forEach(function (value) {
          var size = detectSize(value);
          if (size && product.sizes.indexOf(size) === -1) product.sizes.push(size);
        });
        return product;
      });

      var steps = ['size', 'storage', 'style', 'colour', 'fabric'];
      var stepNames = ['Bed size', 'Storage', 'Style', 'Colour', 'Fabric'];
      var currentStep = 0;
      var resultMode = 'best';
      var visibleLimit = Math.max(4, parseInt(root.dataset.initialLimit || '12', 10));
      var pageSize = visibleLimit;
      var state = { size: null, storage: null, style: [], colour: [], fabric: [] };
      var exactResults = [];
      var compatibleResults = [];

      var progress = root.querySelector('[data-progress]');
      var stepLabel = root.querySelector('[data-step-label]');
      var stepName = root.querySelector('[data-step-name]');
      var navigation = root.querySelector('[data-navigation]');
      var backButton = root.querySelector('[data-back]');
      var nextButton = root.querySelector('[data-next]');
      var skipButton = root.querySelector('[data-skip]');
      var grid = root.querySelector('[data-grid]');
      var empty = root.querySelector('[data-empty]');
      var loadMore = root.querySelector('[data-load-more]');

      function selectedValues(group) {
        return Array.isArray(state[group]) ? state[group] : state[group] ? [state[group]] : [];
      }

      function titleMatches(product, group, selected) {
        if (!selected.length) return true;
        return selected.some(function (value) {
          var phrases = (rules[group] && rules[group][value]) || [normalise(value)];
          return phrases.some(function (phrase) { return hasPhrase(product.titleKey, phrase); });
        });
      }

      function matchesSize(product) {
        return !state.size || product.sizes.indexOf(state.size) > -1;
      }

      function matchesStorage(product) {
        if (state.storage !== 'yes') return true;
        return rules.storage.some(function (phrase) { return hasPhrase(product.titleKey, phrase); });
      }

      function preferenceGroups() {
        return ['style', 'colour', 'fabric'].filter(function (group) { return selectedValues(group).length; });
      }

      function scoreProduct(product) {
        var groups = preferenceGroups();
        var score = groups.reduce(function (total, group) {
          return total + (titleMatches(product, group, selectedValues(group)) ? 1 : 0);
        }, 0);
        if (state.storage === 'yes' && matchesStorage(product)) score += 1;
        return score;
      }

      function buildResults() {
        compatibleResults = products.filter(function (product) {
          return matchesSize(product) && matchesStorage(product);
        });

        var groups = preferenceGroups();
        exactResults = compatibleResults.filter(function (product) {
          return groups.every(function (group) {
            return titleMatches(product, group, selectedValues(group));
          });
        });

        compatibleResults.sort(function (a, b) {
          var scoreDifference = scoreProduct(b) - scoreProduct(a);
          return scoreDifference || a.title.localeCompare(b.title);
        });
        exactResults.sort(function (a, b) { return a.title.localeCompare(b.title); });

        if (!exactResults.length && compatibleResults.length) resultMode = 'all';
        updateTabs();
        renderResults();
      }

      function updateTabs() {
        root.querySelector('[data-best-count]').textContent = exactResults.length;
        root.querySelector('[data-all-count]').textContent = compatibleResults.length;
        root.querySelectorAll('[data-result-mode]').forEach(function (button) {
          var active = button.dataset.resultMode === resultMode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      }

      function createCard(product) {
        var link = document.createElement('a');
        link.className = 'al-finder__card';
        link.href = product.url;

        var media = document.createElement('div');
        media.className = 'al-finder__card-media';
        if (product.image) {
          var image = document.createElement('img');
          image.src = product.image;
          image.alt = product.imageAlt || product.title;
          image.loading = 'lazy';
          image.width = 720;
          image.height = 900;
          media.appendChild(image);
        }

        var groups = preferenceGroups();
        var matched = groups.filter(function (group) {
          return titleMatches(product, group, selectedValues(group));
        }).length;
        var badge = document.createElement('span');
        badge.className = 'al-finder__badge';
        badge.textContent = groups.length ? matched + ' of ' + groups.length + ' preferences' : 'Available in your size';
        media.appendChild(badge);

        var body = document.createElement('div');
        body.className = 'al-finder__card-body';
        var title = document.createElement('p');
        title.className = 'al-finder__card-title';
        title.textContent = product.title;
        var priceRow = document.createElement('div');
        priceRow.className = 'al-finder__price-row';
        var price = document.createElement('span');
        price.className = 'al-finder__price';
        price.textContent = product.price;
        priceRow.appendChild(price);
        if (product.comparePrice) {
          var compare = document.createElement('span');
          compare.className = 'al-finder__compare';
          compare.textContent = product.comparePrice;
          priceRow.appendChild(compare);
        }
        if (!product.available) {
          var soldOut = document.createElement('span');
          soldOut.className = 'al-finder__sold-out';
          soldOut.textContent = 'Sold out';
          priceRow.appendChild(soldOut);
        }
        body.appendChild(title);
        body.appendChild(priceRow);
        link.appendChild(media);
        link.appendChild(body);
        return link;
      }

      function renderResults() {
        var list = resultMode === 'best' ? exactResults : compatibleResults;
        grid.replaceChildren();
        list.slice(0, visibleLimit).forEach(function (product) { grid.appendChild(createCard(product)); });
        empty.hidden = list.length > 0;
        grid.hidden = list.length === 0;
        loadMore.hidden = list.length <= visibleLimit;

        var summary = root.querySelector('[data-results-summary]');
        var heading = root.querySelector('[data-results-heading]');
        if (!compatibleResults.length) {
          heading.textContent = 'Let’s broaden your search';
          summary.textContent = 'No products in the selected collection are available for those essential choices.';
        } else if (!exactResults.length) {
          heading.textContent = 'Closest available matches';
          summary.textContent = 'No title matches every preference, so we’ve ranked all ' + compatibleResults.length + ' compatible beds by relevance.';
        } else if (resultMode === 'best') {
          heading.textContent = 'Your best matches';
          summary.textContent = exactResults.length + ' ' + (exactResults.length === 1 ? 'bed matches' : 'beds match') + ' every selected preference.';
        } else {
          heading.textContent = 'All compatible beds';
          summary.textContent = compatibleResults.length + ' compatible ' + (compatibleResults.length === 1 ? 'bed, ranked' : 'beds, ranked') + ' by how closely their titles match your preferences.';
        }
      }

      function renderPills() {
        var pills = root.querySelector('[data-pills]');
        pills.replaceChildren();
        var labels = {
          size: { 'small-single': 'Small Single', single: 'Single', 'small-double': 'Small Double', double: 'Double', king: 'King', 'super-king': 'Super King' },
          storage: { yes: 'Storage required', no: 'No storage preference' },
          style: { signature: 'Signature', sleigh: 'Sleigh', wingback: 'Wingback', upholstered: 'Upholstered' },
          colour: { cream: 'Cream', beige: 'Beige', white: 'White', mink: 'Mink', grey: 'Grey', charcoal: 'Charcoal', black: 'Black', blue: 'Blue', pink: 'Pink' },
          fabric: { 'boucle-teddy': 'Bouclé & Teddy', chenille: 'Chenille', 'crushed-velvet': 'Crushed Velvet', 'plush-velvet': 'Plush Velvet' }
        };

        Object.keys(state).forEach(function (group) {
          selectedValues(group).forEach(function (value) {
            var pill = document.createElement('button');
            pill.type = 'button';
            pill.className = 'al-finder__pill';
            pill.textContent = (labels[group][value] || value) + ' ×';
            pill.addEventListener('click', function () {
              if (Array.isArray(state[group])) {
                state[group] = state[group].filter(function (item) { return item !== value; });
              } else {
                state[group] = null;
              }
              var option = root.querySelector('[data-group="' + group + '"] [data-value="' + value + '"]');
              if (option) {
                option.classList.remove('is-selected');
                option.setAttribute('aria-pressed', 'false');
              }
              visibleLimit = pageSize;
              renderPills();
              buildResults();
            });
            pills.appendChild(pill);
          });
        });
      }

      function showStep(index) {
        currentStep = Math.max(0, Math.min(index, steps.length - 1));
        root.querySelectorAll('[data-stage]').forEach(function (stage) { stage.hidden = true; });
        root.querySelector('[data-stage="' + steps[currentStep] + '"]').hidden = false;
        stepLabel.textContent = 'Step ' + (currentStep + 1) + ' of ' + steps.length;
        stepName.textContent = stepNames[currentStep];
        progress.style.width = ((currentStep + 1) / (steps.length + 1) * 100) + '%';
        backButton.hidden = currentStep === 0;
        navigation.hidden = false;
      }

      function showResults() {
        root.querySelectorAll('[data-stage]').forEach(function (stage) { stage.hidden = true; });
        root.querySelector('[data-stage="results"]').hidden = false;
        stepLabel.textContent = 'Complete';
        stepName.textContent = 'Your results';
        progress.style.width = '100%';
        navigation.hidden = true;
        visibleLimit = pageSize;
        resultMode = 'best';
        renderPills();
        buildResults();
      }

      root.querySelectorAll('[data-group]').forEach(function (group) {
        group.addEventListener('click', function (event) {
          var button = event.target.closest('[data-value]');
          if (!button || !group.contains(button)) return;
          var name = group.dataset.group;
          var value = button.dataset.value;
          if (group.dataset.mode === 'single') {
            group.querySelectorAll('[data-value]').forEach(function (option) {
              option.classList.remove('is-selected');
              option.setAttribute('aria-pressed', 'false');
            });
            state[name] = value;
            button.classList.add('is-selected');
            button.setAttribute('aria-pressed', 'true');
          } else {
            var selected = state[name].indexOf(value) > -1;
            state[name] = selected ? state[name].filter(function (item) { return item !== value; }) : state[name].concat(value);
            button.classList.toggle('is-selected', !selected);
            button.setAttribute('aria-pressed', String(!selected));
          }
        });
      });

      nextButton.addEventListener('click', function () {
        if (currentStep === steps.length - 1) showResults();
        else showStep(currentStep + 1);
      });
      skipButton.addEventListener('click', function () {
        if (currentStep === steps.length - 1) showResults();
        else showStep(currentStep + 1);
      });
      backButton.addEventListener('click', function () { showStep(currentStep - 1); });
      root.querySelector('[data-restart]').addEventListener('click', function () {
        state = { size: null, storage: null, style: [], colour: [], fabric: [] };
        root.querySelectorAll('[data-value]').forEach(function (button) {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
        });
        showStep(0);
      });
      root.querySelectorAll('[data-result-mode]').forEach(function (button) {
        button.addEventListener('click', function () {
          resultMode = button.dataset.resultMode;
          visibleLimit = pageSize;
          updateTabs();
          renderResults();
        });
      });
      loadMore.addEventListener('click', function () {
        visibleLimit += pageSize;
        renderResults();
      });

      showStep(0);
    }

    function initAll() {
      document.querySelectorAll('.al-finder').forEach(initFinder);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.al-finder');
      if (root) initFinder(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
